module.exports = __webpack_public_path__ + "img/03-2-1数据源.e7974ec5.svg";